import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoaderProvider } from "./context/LoaderContext";

import Loader from "./components/Loader";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Buyers from "./pages/Buyers";
import Sellers from "./pages/Sellers";
import Products from "./pages/Products";
import Users from "./pages/Users";
import Quotation from "./pages/quotation/Quotation";
import QuotationList from "./pages/quotation/QuotationList";
import QuotationInvoice from "./pages/quotation/QuotationInvoice";
import InvoiceCreate from "./pages/invoices/InvoiceCreate";
import SalesInvoice from "./pages/invoices/SalesInvoice";
import InvoiceList from "./pages/invoices/InvoiceList";
import Inventory from "./pages/Inventory";

function App() {
  return (
    <LoaderProvider>
      <div className="App">
        <Loader />
        {/* Toast container yahan hamesha render hoga */}
        <ToastContainer position="top-right" autoClose={3000} />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/buyers" element={<Buyers />} />
          <Route path="/sellers" element={<Sellers />} />
          <Route path="/products" element={<Products />} />
          <Route path="/users" element={<Users />} />
          <Route path="/inventory" element={<Inventory />} />

          <Route path="/create-quotation" element={<Quotation />} />
          <Route path="/quotation-edit/:saleId" element={<Quotation />} />
          <Route path="/quotation-list" element={<QuotationList />} />
          <Route path="/quotation/:saleId" element={<QuotationInvoice />} />

          <Route path="/create-invoice" element={<InvoiceCreate />} />
          <Route path="/invoice-edit/:saleId" element={<InvoiceCreate />} />
          <Route path="/invoice/:saleId" element={<SalesInvoice />} />
          <Route path="/invoices" element={<InvoiceList />} />
        </Routes>
      </div>
    </LoaderProvider>
  );
}

export default App;
